module.exports = __webpack_public_path__ + "static/media/pidilite.fe17c1db.png";